import React from 'react';
import {observer} from 'mobx-react-lite';
import styles from './styles.module.scss';
import {useStore} from '@/store/root-store';

export const StepTwo = observer(() => {
  const {settings: {customer: {profile: {whitelabelOtto}}}} = useStore('');

  return (
    <div className={styles.stepTwo}>
      <div className='diagnosticsAnimation'>
        <img src='/img/DiagnosticsAnimation.gif' alt='Diagnostics Animation' />
      </div>
      <div className='diagnosticsText'>
        <h1>Running Diagnostics...</h1>
        <p>
        We&apos;re checking the selected page for any {whitelabelOtto} implementation issues.<br/> This might take a few seconds — hang tight!
        </p>
        <h2>A detailed report will be ready shortly.</h2>
      </div>

    </div>
  );
});
